import { gql } from '@apollo/client';


export const STORE_USER_DATA = gql`
    mutation storeUserData(
        $hasApplication: Boolean
        $gaClientId: String
        $cityAdsClickId: String
        $gaSessionId: String
        $isAgreementAccepted: Boolean
    ) {
        storeUserData(
            hasApplication: $hasApplication
            gaClientId: $gaClientId
            cityAdsClickId: $cityAdsClickId
            gaSessionId: $gaSessionId
            isAgreementAccepted: $isAgreementAccepted
        ) {
            success
        }
    }
`;
